import React from 'react';
import Style from './style/landingpage.module.css';

function landingPage(){
    return(
        <div className={Style.main}>
            <h1 className={Style.mainHeadding}>Developing your Success Online</h1>
        </div>
    )
};

export default landingPage;